import * as React from 'react';
import * as Redux from 'react-redux';
import { allPaisesAction } from '../PaisesAction';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import * as CONST from '../../../../constants/FieldsConst';
import SelectAutocomplete from '../../../../widgets/SelectAutocomplete';

const SelectFieldPaisesComponent = ({
  onChange,
  value,
  data,
  selects = [],
  isAutoComplete,
}) => {
  const dispatch = Redux.useDispatch();

  const paisesStore = Redux.useSelector((state) => state.paises);

  const [paises, setPaises] = React.useState([]);

  const _handlerSelects = () => {
    let items = [];
    if (selects.length > 0) {
      paisesStore.all.forEach((se) => {
        const existSeletc = selects.some((item) => item.id === se.id);
        if (!existSeletc) items.push(se);
      });
      setPaises(items);
    } else {
      if (data) {
        setPaises(data);
      } else {
        setPaises(paisesStore.all);
      }
    }
  };

  React.useEffect(() => {
    const fetchData = async () => {
      if (!data && paisesStore.all && paisesStore.all.length === 0) {
        await allPaisesAction(dispatch);
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect(async () => _handlerSelects(), [selects]);

  const select = (
    <FormControl fullWidth size="small">
      <InputLabel id={`label_${CONST.pais.name}`}>
        {CONST.pais.label}
      </InputLabel>
      <Select
        id={CONST.pais.name}
        value={value}
        labelId={`label_${CONST.pais.name}`}
        label={CONST.pais.label}
        onChange={(e) => onChange(e.target.value)}
      >
        {paises.map((el, index) => {
          return (
            <MenuItem key={`pais-${index}`} value={el.id}>
              ({el.code}) {el.pais}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );

  const autoComplete = (
    <SelectAutocomplete
      id="combo-box-demo-paises"
      opt={paises}
      type={CONST.pais.name}
      onChange={(event, newValue) => onChange(newValue?.id)}
      l="Paises"
    />
  );

  return isAutoComplete ? autoComplete : select;
};

export default SelectFieldPaisesComponent;
